import React from 'react';
import styled, { keyframes } from 'styled-components';
import { breakpoints } from '@/layouts/breakpoints';

const scroll = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
`;

const StyledComp = styled.div`
  border-bottom: 1px solid #e8e8e5;
  padding: 18px 0;
  display: flex;
  align-items: center;
  overflow: hidden;
  width: 100%;
  max-width: 2160px;
  margin: 0 auto;
  position: relative;
  @media (max-width: ${breakpoints.small}) {
    flex-direction: column;
    gap: 24px;
    padding: 24px 0;
  }

  .label {
    flex-shrink: 0;
    padding: 0 32px;
    font-size: 12px;
    color: #888880;
    white-space: nowrap;
    letter-spacing: 0.01em;
    line-height: 1;
    position: relative;
    z-index: 3;
  }

  .label-fade {
    position: absolute;
    left: 200px;
    top: 0;
    bottom: 0;
    width: 100px;
    background: linear-gradient(to right, #fff 60%, transparent);
    z-index: 2;
    pointer-events: none;
    @media (max-width: ${breakpoints.small}) {
      left: 0px;
    }
  }

  .right-fade {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100px;
    background: linear-gradient(to left, #fff 40%, transparent);
    z-index: 2;
    pointer-events: none;
  }

  .track-wrapper {
    flex: 1;
    overflow: hidden;
    position: relative;
  }

  .track {
    display: flex;
    align-items: center;
    gap: 52px;
    animation: ${scroll} 58s linear infinite;
    width: max-content;

    &:hover {
      animation-play-state: paused;
    }
  }

  .logo-item {
    display: flex;
    align-items: centervisible
    flex-shrink: 0;
    opacity: 0.85;
    transition: opacity 0.2s ease;
    height: 32px;
    padding: 10px 50px;

    @media (max-width: ${breakpoints.medium}) {
      padding: 10px 0px;
    }
    &:hover {
      opacity: 1;
    }

    img {
      height: 100%;
      width: auto;
      object-fit: contain;
    }
  }
`;


const LOGOS = [
  // { name: 'Bloomberg', url: '/logos/bloomberg.svg' },
  { name: 'Kelly School Of Business', url: '/logos/ksb.png' },
  { name: 'Tencent', url: '/logos/tencent.svg' },
  // { name: 'RBC Capital Markets', url: '/logos/rbccm.svg' },
  { name: 'Boston Consulting Group', url: '/logos/bcg.svg' },
  { name: 'Villanova University', url: '/logos/vu.svg' },
  { name: 'The Economist', url: '/logos/economist.svg' },
  { name: 'PwC', url: '/logos/pwc.svg' },
];

const LogoMarquee = ({ label = 'Powering financial research at', logos = LOGOS }) => {
  const quadrupled = [...logos, ...logos, ...logos, ...logos];

  return (
    <StyledComp>

      <span className="label">{label}</span>

      <div>
        <div className="label-fade" />
        <div className="right-fade" />


        <div className="track-wrapper">
          <div className="track">
            {quadrupled.map((logo, i) => (
              <div className="logo-item" key={`${logo.name}-${i}`}>
                <img src={logo.url} alt={logo.name} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </StyledComp>
  );
};

export default LogoMarquee;
